import { __extends } from "tslib";
import { deserializeAws_json1_1GetCelebrityRecognitionCommand, serializeAws_json1_1GetCelebrityRecognitionCommand } from "../protocols/Aws_json1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var GetCelebrityRecognitionCommand = /** @class */ (function (_super) {
    __extends(GetCelebrityRecognitionCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function GetCelebrityRecognitionCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    GetCelebrityRecognitionCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    GetCelebrityRecognitionCommand.prototype.serialize = function (input, context) {
        return serializeAws_json1_1GetCelebrityRecognitionCommand(input, context);
    };
    GetCelebrityRecognitionCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_json1_1GetCelebrityRecognitionCommand(output, context);
    };
    return GetCelebrityRecognitionCommand;
}($Command));
export { GetCelebrityRecognitionCommand };
//# sourceMappingURL=GetCelebrityRecognitionCommand.js.map